import {
  TaxiCorporationOrderBillingsListItem,
  TaxiCorporationOrderBillingsListStats,
} from "../../../../../common/services/taxi-corporation/order-billings/list/taxi-corporation-order-billings-list";
import TaxiCorporationBillingType from "../../../../../common/types/taxi-corporation-billing-type";
import BillingsTaxiOrderListingItem from "./types/billings-taxi-order-listing-item";
import BillingsTaxiOrderListingItemBillingStatus from "./types/billings-taxi-order-listing-item-billing-status";
import BillingsTaxiOrderListingItemBillingType from "./types/billings-taxi-order-listing-item-billing-type";
import BillingsTaxiOrderListingStatsSummary from "./types/billings-taxi-order-listing-stats-summary";

const createListingItemStatus = (
  responseDataItem: TaxiCorporationOrderBillingsListItem,
): BillingsTaxiOrderListingItemBillingStatus | undefined => {
  switch (responseDataItem.status) {
    case "CREATED":
      return BillingsTaxiOrderListingItemBillingStatus.CREATED;
    case "ACCEPTED":
      return BillingsTaxiOrderListingItemBillingStatus.ACCEPTED;
    case "REJECTED":
      return BillingsTaxiOrderListingItemBillingStatus.REJECTED;
    case "REOPENED":
      return BillingsTaxiOrderListingItemBillingStatus.REOPENED;
    case "REOPEN_REQUEST":
      return BillingsTaxiOrderListingItemBillingStatus.REOPEN_REQUEST_SENT;
    default:
      return undefined;
  }
};

const createListingItemBillingType = (
  billingType: TaxiCorporationBillingType,
): BillingsTaxiOrderListingItemBillingType => {
  switch (billingType) {
    case TaxiCorporationBillingType.PRIV_CARGO_2_TAXI:
      return BillingsTaxiOrderListingItemBillingType.PRIV_CARGO_2_TAXI;
    case TaxiCorporationBillingType.PRIV_TAXI_2_RAILY:
      return BillingsTaxiOrderListingItemBillingType.PRIV_TAXI_2_RAILY;
    case TaxiCorporationBillingType.PUB_RAILY_2_TAXI:
      return BillingsTaxiOrderListingItemBillingType.PUB_RAILY_2_TAXI;
  }
};

const createListingItem = (
  responseDataItem: TaxiCorporationOrderBillingsListItem,
): BillingsTaxiOrderListingItem => {
  return {
    uuid: responseDataItem.id,
    internalOrderId: responseDataItem.humanId,
    planEntryHumanIds: responseDataItem.planEntryHumanIds,
    externalOrderId: responseDataItem.externalId,
    orderStartDate: new Date(responseDataItem.date),
    cargoCompanyName: responseDataItem.cargoCompany,
    billingModel: responseDataItem.billingModel,
    billingType: createListingItemBillingType(responseDataItem.billingType),
    status: createListingItemStatus(responseDataItem),
    distance: responseDataItem.distance,
    amountForDistance: responseDataItem.amountForDistance,
    baseDistanceRate: responseDataItem.baseDistanceRate,
    stopoverCost: responseDataItem.amountForChargeHaltings ?? 0,
    tollRoadsCost: responseDataItem.amountForChargeHighways ?? 0,
    totalCost: responseDataItem.allContributionsAmount,
    sumOfDiscounts: responseDataItem.sumOfDiscounts ?? 0,
    passengers: responseDataItem.passengers,
    destinationTaxi: responseDataItem.responsibleTaxi ?? "",
  };
};

const createListingItems = (
  responseDataItems: TaxiCorporationOrderBillingsListItem[],
): BillingsTaxiOrderListingItem[] => {
  return responseDataItems.map(createListingItem);
};

const createStatsSummary = (
  responseStatsSummary: TaxiCorporationOrderBillingsListStats,
): BillingsTaxiOrderListingStatsSummary => {
  return {
    distance: responseStatsSummary.distance,
    amountForChargeHaltings: responseStatsSummary.amountForChargeHaltings,
    amountForChargeHighways: responseStatsSummary.amountForChargeHighways,
    amountForDistance: responseStatsSummary.amountForDistance,
    sumOfDiscounts: responseStatsSummary.sumOfDiscounts,
    allContributionsAmount: responseStatsSummary.allContributionsAmount,
  };
};

const billingsTaxiOrderListingFactory = {
  createListingItems,
  createStatsSummary,
};

export default billingsTaxiOrderListingFactory;
